import { Heading, Inline, Text, Button, Stack, textVariants } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { X as CloseIcon } from '@phosphor-icons/react';
import { css } from '@eti/styles';
import { forwardRef } from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const styles = {
  wrapper: css`
    padding-inline: 16px;
  `,
  header: css`
    justify-content: space-between;
    padding-top: 16px;
  `,
  description: css`
    justify-content: space-between;
    padding: 16px 0 20px;
  `,
  closeButton: css`
    border-width: 0;
    margin-bottom: auto;
    padding: 0;
  `
};
const SeatMapHeader = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    from,
    to,
    currentSegmentIndex,
    totalSegmentsCount,
    currentSegmentData,
    handleCloseButton,
    isSummaryShowing
  } = _ref;
  const {
    t
  } = useTranslation();
  const labels = {
    closeButton: t('ScreenReader.CloseButtonDialog.AriaLabel.Text'),
    detailsDescription: currentSegmentData ? t('Seating.Segments.Details.Description', currentSegmentIndex, totalSegmentsCount, currentSegmentData.from.iata, currentSegmentData.to.iata) : undefined,
    header: t('Product.SeatMap.Header.Label'),
    to: String(t('ScreenReader.To.AriaLabel.Text')).toLowerCase()
  };
  return /*#__PURE__*/_jsxs(Stack, {
    className: styles.wrapper,
    ref: ref,
    spacing: 0,
    children: [/*#__PURE__*/_jsxs(Inline, {
      className: styles.header,
      "data-testid": "seatMap-header",
      children: [/*#__PURE__*/_jsx(Heading, {
        "data-testid": "seatMap-heading",
        level: 2,
        children: labels.header
      }), /*#__PURE__*/_jsx(Button, {
        "aria-label": labels.closeButton,
        className: styles.closeButton,
        "data-testid": "seatMap-closeIcon-button",
        onClick: handleCloseButton,
        type: "button",
        children: /*#__PURE__*/_jsx(CloseIcon, {
          "aria-hidden": "true",
          size: 25
        })
      })]
    }), !isSummaryShowing && /*#__PURE__*/_jsxs(Inline, {
      className: styles.description,
      children: [/*#__PURE__*/_jsxs(Text, {
        "aria-label": `${from} ${labels.to} ${to}`,
        "data-testid": "seatMap-segment-description",
        variant: textVariants._16_BOLD,
        children: [from, " \u2013 ", to]
      }), labels.detailsDescription && currentSegmentIndex > 0 && totalSegmentsCount > 0 && /*#__PURE__*/_jsx(Text, {
        "data-testid": "seatMap-segments-text",
        variant: textVariants._14,
        children: labels.detailsDescription
      })]
    })]
  });
});
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map